<template>
  <div>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    <div class="text-left" style="padding-top:0%" :style="viewStyle">
      <!-- Tabs -->
      <v-row class="ma-0 pt-2" style="padding-left: 20px; background:#FFF">
        <v-tabs color="#ED6D00" background-color="transparent">
          <v-tabs-slider color="#ED6D00"></v-tabs-slider>
          <v-tab>{{$t('__Customer')}}</v-tab>
        </v-tabs>
      </v-row>

      <div id="box" style="margin-top:3%">
        <v-row class="pb-5">
          <v-icon class="ma-0 pa-0 primary-color" size="28">mdi-menu-right</v-icon>
          <h4 class="primary-color" style="padding-top:2px">{{$t('__Customer')}}</h4>
        </v-row>
        
        <v-form ref="form" v-model="valid" lazy-validation :disabled="!canEdit">
          <v-row class="mx-2">
             <!-- Left Column -->
            <v-col class="pa-0 col-12 col-md-6">
              
              <v-row class="ma-0">
                <v-col class="px-0 col-2 col-md-4">
                  <div class="text-right pt-2 pt14"><span class="start">*</span>{{$t('__customerName')}}</div>
                </v-col>
                <v-col class="col-10 col-md-8">
                  <v-text-field class="text_field" dense background-color="white" outlined v-model="datasets.name"></v-text-field>
                </v-col>
              </v-row>

              <v-row class="ma-0">
                <v-col class="px-0 col-2 col-md-4">
                  <div class="text-right pt-2 pt14">{{$t('__contactPerson')}}</div>
                </v-col>
                <v-col class="col-10 col-md-8">
                  <v-text-field class="text_field" dense background-color="white" outlined v-model="datasets.contactPerson"></v-text-field>
                </v-col>
              </v-row>
              
              <v-row class="ma-0">
                <v-col class="px-0 col-2 col-md-4">
                  <div class="text-right pt-2 pt14">{{$t('__tel')}}</div>
                </v-col>
                <v-col class="col-10 col-md-8">
                  <v-text-field class="text_field" dense background-color="white" outlined v-model="datasets.phoneNumber"></v-text-field>
                </v-col>
              </v-row>

              <v-row class="ma-0">
                <v-col class="px-0 col-2 col-md-4">
                  <div class="text-right pt-2 pt14">{{$t('__email')}}</div>
                </v-col>
                <v-col class="col-10 col-md-8">
                  <v-text-field class="text_field" dense background-color="white" outlined v-model="datasets.emailAddress"></v-text-field>
                </v-col>
              </v-row>
            </v-col>

            <!-- Right Column -->
            <v-col class="pa-0 col-12 col-md-6">
              
              <v-row class="ma-0">
                 <v-col class="px-0 col-2 col-md-4">
                  <div class="text-right pt-2 pt14">{{$t('__address')}}</div>
                </v-col>
                <v-col class="col-10 col-md-8">
                   <v-text-field class="text_field" dense background-color="white" outlined v-model="datasets.address"></v-text-field>
                </v-col>
              </v-row>

               <v-row class="ma-0" v-if="datasets.createTime">
                <v-col class="px-0 col-2 col-md-4">
                  <div class="text-right pt-2 pt14">{{$t('__createTime')}}</div>
                </v-col>
                <v-col class="col-10 col-md-8">
                  <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.createTime"></v-text-field>
                </v-col>
              </v-row>
               <v-row class="ma-0" v-if="datasets.updateTime">
                <v-col class="px-0 col-2 col-md-4">
                  <div class="text-right pt-2 pt14">{{$t('__updateTime')}}</div>
                </v-col>
                <v-col class="col-10 col-md-8">
                  <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.updateTime"></v-text-field>
                </v-col>
              </v-row>

            </v-col>
          </v-row>
        </v-form>
      </div>
    </div>
    
    <v-footer id="footer">
      <div class="text-center mx-auto footer">
        <v-btn class="btn" large color="#979491" style="color: #FFF; box-shadow:none" @click="redirectPath('/Configuration')">{{$t('__cancel')}}</v-btn>
        <v-btn v-if="canEdit" class="btn" large color="#ED6D00" style="color: #FFF; box-shadow:none" @click="saveDataset()">{{$t('__save')}}</v-btn>
      </div>
    </v-footer>
    <ShowMsg ref="ShowMsg" :onSave="onSaveSuccess" />
  </div>
</template>

<script>
import i18n from '@/plugins/i18n'
import ShowMsg from '@/dialogs/ShowMsg'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.min.css'
import { getEmployeeInfo } from '@/utils/auth'

export default {
  name: 'Customer',
  components: {ShowMsg, Loading},
  data: () => ({
    isLoading: false,
    valid: true,
    viewStyle: {},
    addNewData:0, //0-新增 1-修改
    datasets: {
      id: '',
      name: '',
      contactPerson: '',
      phoneNumber: '',
      address: '',
      emailAddress: '',
      createTime: '',
      updateTime: ''
    },
    language: ''
  }),
  computed: {
    canEdit() {
      try {
        const info = getEmployeeInfo()
        if (info && info.function) {
          const perms = JSON.parse(info.function)
          const p = perms.find(e => e.key === 'Configuration')
          return p ? !!p.edit : false
        }
      } catch (e) {
        console.error('Failed to parse permissions:', e)
      }
      return false
    }
  },
  mounted() {
    this.language = i18n.locale
    this.addNewData = (this.$route.query.id == -1) ? 0 : 1
    this.checkMode()
  },
  created() {
    this.calculateWindows()
    this.$root.$on('windowInnerHeight', () => {
      this.calculateWindows()
    })
    this.$root.$on('language', (value) => {
      this.language = value
    })
  },
  methods: {
    calculateWindows() {
      this.viewStyle = {height: window.innerHeight - 135 + 'px'}
    },
    redirectPath(path) {
      this.$router.push({ path: path, query: { page: this.$route.query.page, tab: 2 } })
    },
    onSaveSuccess() {
      this.redirectPath('/Configuration')
    },
    checkMode() {
      if(this.addNewData != 0){
        this.getDataset(this.$route.query.id)
      } else {
        // Init empty or defaults
      }
    },
    getDataset(id) {
      this.isLoading = true
      var self = this
      var request = {
        method: 'GET',
        url: '/GetCustomer', 
        params: { id: id },
      }
      this.$http(request).then(function(response) {
        if (response.data.Data) {
          self.datasets = response.data.Data
        } else if (response.data.data) {
          self.datasets = response.data.data
        } else {
          self.datasets = response.data
        }
      }).catch(() => {
        self.$refs.ShowMsg.open(0, self.$t('__error'), self.$t('__getDataError'))
      }).finally(() => {
        self.isLoading = false
      })
    },
    saveDataset() {
      if (!this.$refs.form.validate()) return

      // Manual required field check
      if (!this.datasets.name) {
        this.$refs.ShowMsg.open(1)
        return
      }

      if(this.datasets.emailAddress){
        // Email format check
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        if (!emailRegex.test(this.datasets.emailAddress)) {
          this.$refs.ShowMsg.open(0, this.$t('__error'), this.$t('__invalidEmail'))
          return
        }
      }

      this.isLoading = true
      var self = this
      // Use CreateCustomer for new records, UpdateCustomer for existing
      var url = this.datasets.id ? '/UpdateCustomer' : '/CreateCustomer'
      var method = 'POST' 
      
      // Prepare data for API
      var requestData
      if (this.datasets.id) {
        requestData = this.datasets
      } else {
        requestData = {
          name: this.datasets.name,
          contactPerson: this.datasets.contactPerson || '',
          phoneNumber: this.datasets.phoneNumber || '',
          address: this.datasets.address || '',
          emailAddress: this.datasets.emailAddress || ''
        }
      }

      var request = {
        method: method,
        url: url,
        headers: {
          'Content-Type': 'application/json-patch+json'
        },
        data: requestData
      }
      this.$http(request).then(function(response) {
        if (response.data.State === '988' || response.data.State === '9882' || response.data.State === '9883') {
          self.$refs.ShowMsg.open(0, self.$t('__error'), self.$t('__customerNameExists'))
        } else {
          self.$refs.ShowMsg.open(0, self.$t('__savedSuccessfully'), response.data.Message, true) 
        }
      }).catch((error) => {
        console.error('Save error:', error)
        var errorMsg = error.response?.data?.Message || self.$t('__saveFailed')
        self.$refs.ShowMsg.open(0, self.$t('__error'), errorMsg)
      }).finally(() => {
        self.isLoading = false
      })
    }
  }
}
</script>